import styled from 'styled-components';

/* === Page Wrapper === */
export const BroadcastWrapper = styled.div`
    padding: 2rem 3rem;
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    background: linear-gradient(180deg, #0f1115 0%, #0b0c0f 100%);
    color: #eef6ff;

    @media (min-width: 1200px) {
        padding: 3rem 8rem;
    }
`;

/* === 제목 === */
export const PageTitle = styled.h1`
    font-size: 2.4rem;
    font-weight: 700;
    margin-bottom: 25px;
    color: #ffffff;
`;

/* === 메인 그리드: 왼쪽(비디오) / 오른쪽(컨트롤) === */
export const BroadcastGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 28px;

    @media (min-width: 1100px) {
        grid-template-columns: 2fr 1fr;
    }
`;

/* === 영상 섹션 === */
export const VideoPanel = styled.div`
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 14px;
    padding: 20px;
    height: 900px;
    position: relative;
    box-shadow: 0 6px 18px rgba(3, 3, 10, 0.6);
`;

export const PreparationBox = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px dashed rgba(255, 255, 255, 0.08);
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 14px;

    h3 {
        font-size: 1.7rem;
        color: #eaf6ff;
        margin: 0;
    }

    h6 {
        color: #9ac7ef;
        font-size: 1rem;
        margin: 0;
    }
`;

export const DevicePreviewGrid = styled.div`
    margin-top: 30px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 18px;

    @media (min-width: 800px) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const DevicePreviewItem = styled.div`
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 4px 12px rgba(3, 3, 10, 0.45);

    video {
        width: 100%;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 10px;
    }

    h4 {
        font-size: 1.1rem;
        margin: 0;
        color: #cfeeff;
        text-align: center;
    }
`;

/* === 컨트롤 패널 === */
export const ControlPanel = styled.section`
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 6px 18px rgba(3, 3, 10, 0.6);
`;

export const ControlSection = styled.div`
    margin-bottom: 30px;
`;

export const ControlTitle = styled.h3`
    font-size: 1.4rem;
    margin-bottom: 12px;
    color: #ffffff;
`;

/* === 장치 선택 === */
export const SelectDevice = styled.select`
    width: 100%;
    padding: 12px 14px;
    border-radius: 8px;
    background: #1b2630;
    color: #e6f7ff;
    border: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 1rem;
    cursor: pointer;
`;

/* === 권한 아이콘 === */
export const PermissionRow = styled.div`
    display: flex;
    gap: 14px;
    margin-top: 10px;
`;

export const PermissionButton = styled.button<{$disabled?: boolean}>`
    width: 58px;
    height: 58px;
    background: #1b2630;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
    transition: all 0.2s ease;

    ${(p) =>
        p.$disabled &&
        `
        opacity: 0.35;
        cursor: not-allowed;
    `}

    &:hover {
        background: #0f4f83;
    }

    img {
        width: 30px;
        height: 30px;
    }
`;

/* === 버튼 그룹 === */
export const ButtonGroup = styled.div`
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
`;

/* === 비디오 패널 오버레이 컨트롤 바 === */
export const VideoOverlayBar = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 24px;
    border-radius: 0 0 14px 14px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.75) 0%, transparent 100%);
    display: flex;
    gap: 12px;
    justify-content: center;
`;

export const ActionButton = styled.button<{$variant?: string; $disabled?: boolean}>`
    padding: 10px 16px;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.15s ease;

    ${(p) =>
        p.$variant === 'primary' &&
        `
        background: #00bfff;
        color: #000;
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 0 12px rgba(0,191,255,0.35);
        }
    `}

    ${(p) =>
        p.$variant === 'secondary' &&
        `
        background: #1b2630;
        color: #cfeeff;
        &:hover {
            background: #0f4f83;
        }
    `}

    ${(p) =>
        p.$variant === 'danger' &&
        `
        background: #8b1f2d;
        color: #fff;
        &:hover {
            background: #a12938;
        }
    `}

    ${(p) =>
        p.$disabled &&
        `
        opacity: 0.45;
        cursor: not-allowed;
        transform: none !important;
    `}
`;
